export default class SEPTARegionalPositionalSystem {
    static yards_per_mile = 1760;
    static feet_per_mile = 5280;
    static display_formats = {
        line_mile_feet: "Miles and Feet",
        line_mile_yards: "Miles and Yards",
    };

    static display_fields = {
        LINE: {
            name: "Line",
            rules: [{ required: true }],
        },
        MILE: {
            name: "Mile",
            rules: [{ required: true, type: "integer" }],
        },
        YARDS: {
            name: "Yards",
            rules: [{ required: true, type: "integer", min: 0, max: 1759 }],
        },
        FEET: {
            name: "Feet",
            rules: [{ required: true, type: "integer", min: 0, max: 5279 }],
        },
        TRACK: {
            name: "Track",
            rules: [{}],
        },
    };

    fields(display_format) {
        return SEPTARegionalPositionalSystem.fields(display_format);
    }

    static fields(display_format) {
        if (display_format === "line_mile_feet") {
            return ["LINE", "TRACK", "MILE", "FEET"];
        } else {
            return ["LINE", "TRACK", "MILE", "YARD"];
        }
    }

    displayFields(display_format) {
        return SEPTARegionalPositionalSystem.displayFields(display_format);
    }

    static displayFields(display_format) {
        if (display_format === "line_mile_feet") {
            return ["LINE", "TRACK", "MILE", "FEET"];
        } else {
            return ["LINE", "TRACK", "MILE", "YARD"];
        }
    }

    field_value(field) {
        switch (field) {
            case "LINE":
                return this.line;
            case "MILE":
                return this.mile;
            case "YARD":
                return this.yards;
            case "FEET":
                return this.feet;
            case "TRACK":
                return this.track;
            default:
                return null;
        }
    }

    static from_fields(system_id, display_format, fields) {
        if (display_format === "septaregional") {
            const position = fields.MARKER + fields.FEET / SEPTARegionalPositionalSystem.feet_per_mile;
            return new SEPTARegionalPositionalSystem(system_id, fields.LINE, position, fields.TRACK);
        } else {
            const position = fields.MARKER + fields.YARD / SEPTARegionalPositionalSystem.yards_per_mile;
            return new SEPTARegionalPositionalSystem(system_id, fields.LINE, position, fields.TRACK);
        }
    }

    static from_search(system_id, fields) {
        const position = parseInt(fields.paramTwo) + parseInt(fields.paramThree) / SEPTARegionalPositionalSystem.yards_per_mile;
        return new SEPTARegionalPositionalSystem(system_id, fields.paramOne, position, null);
    }

    constructor(system_id, route, position, subposition, sources) {
        this.system = system_id;
        this.route = this.line = route;
        this.position = position;
        this.subposition = this.track = subposition;
        this.sources = sources;
        this.sign = position >= 0 ? 1 : -1;
        if (this.sign < 0) {
            position = Math.abs(position);
        }
        this.mile = Math.floor(position);
        this.yards = Math.floor((position - this.mile) * SEPTARegionalPositionalSystem.yards_per_mile);
        this.feet = Math.floor((position - this.mile) * SEPTARegionalPositionalSystem.feet_per_mile);
    }

    to_mile_and_yard_string() {
        const prefix = this.sign < 0 ? "-" : "";
        const yard = Math.floor(this.yards).toString().padStart(4, "0");
        return `Mile ${prefix}${this.mile} Yard: ${yard}`;
    }

    to_mile_and_feet_string() {
        const prefix = this.sign < 0 ? "-" : "";
        const feet = Math.floor(this.feet).toString().padStart(4, "0");
        return `Mile ${prefix}${this.mile} Feet: ${feet}`;
    }

    to_string(display_format, isHorizontal) {
        let trackLabel = "Track ";
        if (isHorizontal) {
            trackLabel = "";
        }
        let position;
        if (display_format === "line_mile_feet") {
            position = this.to_mile_and_feet_string();
        } else {
            position = this.to_mile_and_yard_string();
        }
        if (this.track !== null) {
            return `${this.line} ${trackLabel}${this.track} ${position}`;
        } else {
            return `${this.line} ${position}`;
        }
    }

    to_simple_string(display_format, remove_label) {
        let position;
        if (display_format === "line_mile_feet") {
            position = this.to_mile_and_feet_string();
        } else {
            position = this.to_mile_and_yard_string();
        }
        if (remove_label) {
            return `${position}`;
        } else {
            return `${this.line} ${position}`;
        }
    }
}
